module.exports = __webpack_public_path__ + "static/media/ar.4a30d4b2.svg";